import { render, staticRenderFns } from "./Requisicoes.vue?vue&type=template&id=5723c51c&scoped=true"
import script from "./Requisicoes.vue?vue&type=script&lang=js"
export * from "./Requisicoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5723c51c",
  null
  
)

export default component.exports